/**
 * Shared query defaults and conventions following TKDodo best practices
 * @see https://tkdodo.eu/blog/effective-react-query-keys
 * @see https://tkdodo.eu/blog/practical-react-query
 */

import { type UseQueryOptions } from '@tanstack/vue-query'

/**
 * Default query options applied to most queries
 */
export const defaultQueryOptions = {
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  retry: 0,
} satisfies Partial<UseQueryOptions>
